import 'fslightbox';
import {createApp} from '../../node_modules/vue/dist/vue.esm-bundler';

import Accordion from './modules/Accordion';
import NotificationBox from './modules/NotificationBox';
import Modal from './modules/Modal';
import stickAreaObserver from './modules/StickyAreaObserver';
import mobileNavigation from './modules/MobileNavigation';
import nfxSwiper from './modules/NfxSwiper';
import tabs from './modules/Tabs';
import InsuranceTable from './modules/InsuranceTable';
import VersionSwitcher from './modules/VersionSwitcher';
import VideoBlock from './modules/VideoBlock';

import ContactForm from './components/ContactForm.vue';
import ContactInfoBox from './components/ContactInfoBox.vue';
import TerminationLeasingForm from './components/TerminationLeasingForm.vue';

Accordion.init();
NotificationBox.init();
Modal.init();
stickAreaObserver.init();
mobileNavigation.init();
nfxSwiper.init();
tabs.init();
InsuranceTable.init();
VersionSwitcher.init();
VideoBlock.init();

const contactFormElement = document.querySelector('.vue-contact-form');
if (contactFormElement) {
    const contactFormApp = createApp({});
    contactFormApp.component('contact-form', ContactForm);
    contactFormApp.mount('.vue-contact-form');
}

const contactInfoBoxElement = document.querySelector('.vue-contact-info-box');
if (contactInfoBoxElement) {
    const contactInfoBoxApp = createApp({});
    contactInfoBoxApp.component('contact-info-box', ContactInfoBox);
    contactInfoBoxApp.mount('.vue-contact-info-box');
}

const terminationLeasingFormElement = document.querySelector('.vue-termination-leasing-form');
if (terminationLeasingFormElement) {
    const terminationLeasingFormApp = createApp({});
    terminationLeasingFormApp.component('termination-leasing-form', TerminationLeasingForm);
    terminationLeasingFormApp.mount('.vue-termination-leasing-form');
}

const cookieSettingsLink = document.evaluate('//a[contains(text(), \'Cookie-Einstellungen\') or contains(text(), \'Paramètres des cookies\') or contains(text(), \'Cookie settings\')]', document, null, XPathResult.ANY_TYPE, null );

if (cookieSettingsLink) {
    try {
        let currentNode = cookieSettingsLink.iterateNext();

        while (currentNode) {
            currentNode.addEventListener('click', (event) => {
                event.preventDefault();
                UC_UI.showSecondLayer();
            });
            currentNode = cookieSettingsLink.iterateNext();
        }
    } catch (e) { }
    // cookieSettingsLink.addEventListener('click', (event) => {
    //     event.preventDefault();
    //     UC_UI.showSecondLayer();
    // });
}

const accessibleClicks = document.querySelectorAll('.js-accessible-click');
if (accessibleClicks.length > 0) {
    accessibleClicks.forEach((tab) => {
        tab.addEventListener('keydown', (event) => {
            event.preventDefault();
            if (event.code === 'Enter' || event.key === 'Space') {
                tab.click();
            }
        });
    });
}